import { useTheme } from "@mui/material/styles";
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { usePartyPlayTrialMode } from "../../party/usePartyPlayTrialMode";
import type { PartyShellPalette } from "../../theme/theme";
import { PartyPlayImposterOnline } from "./PartyPlayImposterOnline";

/**
 * Party shell `imposter-online`: only the Kan-hosted flow (no local imposter lobby).
 */
export default function PartyPlayImposterOnlineOnly() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const partyPal = (useTheme().palette as unknown as { party: PartyShellPalette }).party;
  const isTrialMode = usePartyPlayTrialMode();
  const onlineJoinParam = searchParams.get("onlineJoin");
  const onlineFlowParam = searchParams.get("onlineFlow");
  const initialDetailOnlineFlow =
    onlineFlowParam === "private" || onlineFlowParam === "public" ? onlineFlowParam : null;

  return (
    <PartyPlayImposterOnline
      partyPal={partyPal}
      isTrialMode={isTrialMode}
      initialJoinCode={onlineJoinParam}
      initialDetailOnlineFlow={initialDetailOnlineFlow}
      onExit={() => navigate("/party/detail/imposter-online", { replace: true })}
    />
  );
}
